import { EntityParams } from "app/models/entity-params";
import { EntityProfileParams } from "app/models/entity-profile-params";
import { removeExistingActives } from "app/views/components/functions/removeExistingActives";

type CSVRow = Record<string, string | null | undefined>;
type EntityTypeOption = {
    label: string;
    value: string;
};

export type SubmissionObject = {
    id: string | null;
    entityName: string;
    entityType: string | null;
    entityProfile: string[];
    entityReference: string | null;
    address: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    zipCode: string | null;
    country: string | null;
    kycType: string | null;
    kycStatus: string;
    institutionType: string | null;
    countryOfIncorporation: string | null;
    countryOfTaxResidence: string | null;
    taxFormStatus: string | null;
    taxFormExpirationDate: string | null;
    usTaxFormType: string | null;
    fundManager: string | null;
    fundManagerMei: string | null;
    parent: string | null;
    parentMei: string | null;
    giin: string | null;
    crn: string | null;
    naicCode: string | null;
    internalId: string | null;
    legalEntityId: string | null;
    mei: string | null;
    ein: string | null;
    cei: string | null;
    ukTreatyPassportNumber: string | null;
    status: string;
    ukTreatyPassportExpiryDate: string | null;
    entityParty: string | null;
    hasError: boolean;
    ErrorMessage: string;
    hasSuccessfulEntitySave: boolean;
    customer_token: string;
};

export function transformCSVToSubmission(
    csvRows: CSVRow[],
    entities: EntityParams[],
    entityTypeOptions: EntityTypeOption[],
    entityProfiles: EntityProfileParams[],
    transformValues: (values: SubmissionObject) => EntityParams
): EntityParams[] {

    const processedRows = removeExistingActives(csvRows, entities);

    return processedRows.map((row) => {
        const entityType = entityTypeOptions.find((type) => type.label === row["Entity Type"])?.value || null;
        const entityProfile = entityProfiles
            .filter((profile) => profile.isActive && profile.name === row["Entity Profile"])
            .map((profile) => profile?.id ?? '');

        const updatedRow = {
            id: entities.filter(entity => entity.status === 'Inactive').find(entity => entity?.internalId === row["Internal Entity ID"])?.id || null,
            entityName: row["Entity Name"] || "",
            entityType: entityType || null,
            entityProfile: entityProfile || [],
            entityReference: row["Entity Reference"] || null,
            address: row["Address"] || null,
            address2: row["Address 2"] || null,
            city: row["City"] || null,
            state: row["State/Region"] || null,
            zipCode: row["Zip/Postal Code"] || null,
            country: row["Country/Region"] || null,
            kycType: row["KYC Type"] || 'NA',
            kycStatus: row["KYC Status"] || "PendingKycStatus",
            institutionType: row["Institution Type"] || "FinancialInstitution",
            countryOfIncorporation: row["Country of Incorporation"] || null,
            countryOfTaxResidence: row["Country of Tax Residence"] || null,
            taxFormStatus: row["Tax Form Status"] || null,
            taxFormExpirationDate: row["Tax Form Expiration Date"] || null,
            usTaxFormType: row["US Tax Form Type"] || null,
            fundManager: row["Fund Manager"] || null,
            fundManagerMei: row["Fund Manager MEI"] || null, // Example placeholder
            parent: row["Parent"] || null,
            parentMei: row["Parent MEI"] || null,
            giin: row["GIIN"] || null,
            crn: row["CRN"] || null,
            naicCode: row["NAIC"] || null,
            internalId: row["Internal Entity ID"] || null,
            systemId: row["System ID"] || null,
            legalEntityId: row["LEI"] || null,
            mei: row["MEI"] || null,
            ein: row["EIN"] || null,
            cei: row["CEI"] || null,
            ukTreatyPassportNumber: null,
            status: "Inactive",
            ukTreatyPassportExpiryDate: null,
            entityParty: null,
            hasError: false,
            ErrorMessage: "",
            hasSuccessfulEntitySave: false,
            customer_token: "RIGHTPEDAL",
        };
        return transformValues(updatedRow);
    });
}
